import { createStore } from "vuex"

import { LoginModule } from './login';
import { ConferenceCallModule } from './conferenceCall';
import { ServiceModule } from './service';
import { PresentationModule } from './presentation'
import { GlobalModule } from './globalStore'; 
import { EmailValidationModule } from './emailValidation';
import { GlobalNumbersModule } from './globalNumbers';
// import { QuestionsModule } from './askAQuestion';
import { BrandingModule } from './corporateBranding';

// Vue.use(Vuex);

export default createStore({
  modules: {
    emailValidation: EmailValidationModule,
    login: LoginModule,
    conferenceCall: ConferenceCallModule,
    service: ServiceModule,
    presentation: PresentationModule,
    global: GlobalModule,
    globalNumbers: GlobalNumbersModule,
    corporateBranding: BrandingModule,
  }
});
